import { ACTION_COSTS, FREE_MONTHLY_CREDITS, formatCredits } from "../constants/credits";

/**
 * Copy only: the server remains authoritative when preparation is submitted.
 * Read the original account payload, not a coerced/null-to-zero balance or a
 * checkout-return stash. Suppress affordability claims while a read is stale.
 * @param {{signedIn: boolean, account: any, loading: boolean, error: boolean,
 *   cost: number, pending?: boolean}} state
 * @returns {{balance: number | null | undefined, message: string}}
 */
export const confirmationCreditCopy = ({ signedIn, account, loading, error, cost, pending }) => {
  if (!signedIn) {
    return {
      balance: undefined,
      message: `Free-plan accounts receive ${formatCredits(FREE_MONTHLY_CREDITS)} each month. Sign in or create a free account to check your available balance.`,
    };
  }
  const raw = account?.credits?.balance;
  const balance = !loading && !error && Number.isSafeInteger(raw) && raw >= 0 ? raw : null;
  if (pending) {
    return {
      balance,
      message: "A preparation request is already saved. Check its status before starting another.",
    };
  }
  if (loading) return { balance: null, message: "Checking your available credits…" };
  if (balance === null) {
    return {
      balance,
      message:
        "Your credit balance is unavailable. We’ll check it when you prepare; no balance is assumed.",
    };
  }
  const extras = cost > ACTION_COSTS.analysis;
  if (balance >= cost) {
    const plan = account.credits.plan_key === "free" ? "Free-plan " : "";
    return {
      balance,
      message: `Your displayed ${plan}balance covers ${extras ? "the analysis and selected extras" : "this analysis"}.`,
    };
  }
  if (balance >= ACTION_COSTS.analysis) {
    return {
      balance,
      message: `Your displayed balance covers the analysis. You need ${formatCredits(cost - balance)} more for the selected extras, or uncheck them to prepare just the analysis.`,
    };
  }
  return {
    balance,
    message: `You need ${formatCredits(ACTION_COSTS.analysis - balance)} more for the analysis${extras ? `, or ${formatCredits(cost - balance)} more with your selected extras` : ""}. You can review credit options when you continue.`,
  };
};
